"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContainer = exports.toast = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svg_1 = require("@obvio/svg");
const utils_1 = require("@obvio/utils");
const react_toastify_1 = require("react-toastify");
const components_1 = require("./components");
const defaultOptions = (type) => ({
    position: react_toastify_1.toast.POSITION.BOTTOM_CENTER,
    hideProgressBar: true,
    closeOnClick: true,
    draggable: false,
    pauseOnHover: true,
    autoClose: ['warning', 'error'].includes(type !== null && type !== void 0 ? type : '')
        ? false
        : 4000,
    icon: type === 'success'
        ? svg_1.SvgCheckCircle
        : type === 'info'
            ? svg_1.SvgInfo
            : type === 'error'
                ? svg_1.SvgAlertOctagon
                : false,
});
const toastBase = (type) => (content, options) => (0, react_toastify_1.toast)(content, Object.assign(Object.assign(Object.assign({}, defaultOptions(type)), (0, utils_1.exclude)({ type }, undefined)), (0, utils_1.exclude)(options !== null && options !== void 0 ? options : {}, undefined)));
exports.toast = {
    basic: toastBase(),
    success: toastBase(react_toastify_1.toast.TYPE.SUCCESS),
    error: toastBase(react_toastify_1.toast.TYPE.ERROR),
    warn: toastBase(react_toastify_1.toast.TYPE.WARNING),
};
function ToastContainer(_a) {
    var { newestOnTop = true } = _a, props = __rest(_a, ["newestOnTop"]);
    return (0, jsx_runtime_1.jsx)(components_1.Container, Object.assign({ transition: react_toastify_1.Zoom, newestOnTop: newestOnTop }, props));
}
exports.ToastContainer = ToastContainer;
